import CategoriesTooltip from './CategoriesTooltip';
export default CategoriesTooltip;
